/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_User_List_Role_Badge_CompanyInputs */

const en_admin_user_list_role_badge_company = /** @type {(inputs: Admin_User_List_Role_Badge_CompanyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`company`)
};

const de_admin_user_list_role_badge_company = /** @type {(inputs: Admin_User_List_Role_Badge_CompanyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unternehmen`)
};

/**
* | output |
* | --- |
* | "company" |
*
* @param {Admin_User_List_Role_Badge_CompanyInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const admin_user_list_role_badge_company = /** @type {((inputs?: Admin_User_List_Role_Badge_CompanyInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_User_List_Role_Badge_CompanyInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_admin_user_list_role_badge_company(inputs)
	return en_admin_user_list_role_badge_company(inputs)
});